(() => {
  const boot = document.getElementById('gallery-pilot-config');
  if (!boot) return;
  const config = JSON.parse(boot.textContent);
  if (config.mediaCount !== config.imageCount) return;
  const wrapper = document.querySelector('product-info .product__media-wrapper');
  if (!wrapper) return;
  Promise.all([
    fetch(config.dataUrl).then(r => { if (!r.ok) throw Error('Gallery data unavailable'); return r.json(); }),
    fetch(config.productUrl + '.js').then(r => { if (!r.ok) throw Error('Product data unavailable'); return r.json(); })
  ]).then(([data, product]) => {
    const mapping = data[config.handle] || {groups:{}, variants:{}};
    const allImages = (product.images || []).map(src => ({src:new URL(src, location.origin).href, alt:product.title + ' ' + config.labels.photo}));
    if (!allImages.length) return;
    let verified = Boolean(data[config.handle]);
    if (!verified && product.variants.length === 1) {
      const id = String(product.variants[0].id);
      mapping.variants[id] = id; mapping.groups[id] = allImages;
      verified = true;
    }
    if (!verified) {
      for (const variant of product.variants) {
        const src = variant.featured_image?.src || product.featured_image;
        if (!src) continue;
        const key = String(variant.id);
        mapping.variants[key] = key;
        mapping.groups[key] = [{src:new URL(src, location.origin).href, alt:product.title + ', ' + variant.title}];
      }
    }
    const root = document.createElement('div');
    root.className = 'gallery-pilot';
    const main = document.createElement('button');
    main.type = 'button'; main.className = 'gallery-pilot-main'; main.setAttribute('aria-label', config.labels.zoom);
    const image = document.createElement('img'); image.width = 1000; image.height = 1000; main.append(image);
    const controls = document.createElement('div'); controls.className = 'gallery-pilot-controls';
    const previous = document.createElement('button'); previous.type = 'button'; previous.textContent = '←'; previous.setAttribute('aria-label', config.labels.previous);
    const counter = document.createElement('span'); counter.setAttribute('aria-live', 'polite');
    const next = document.createElement('button'); next.type = 'button'; next.textContent = '→'; next.setAttribute('aria-label', config.labels.next);
    controls.append(previous, counter, next);
    const thumbs = document.createElement('div'); thumbs.className = 'gallery-pilot-thumbs';
    const dialog = document.createElement('dialog'); dialog.className = 'gallery-pilot-dialog'; dialog.setAttribute('aria-label', config.labels.zoom);
    const close = document.createElement('button'); close.type = 'button'; close.textContent = config.labels.close;
    const zoom = document.createElement('img'); dialog.append(close, zoom);
    const more = document.createElement('details'); more.className = 'gallery-pilot-more';
    const summary = document.createElement('summary'); summary.textContent = config.labels.more;
    const extraThumbs = document.createElement('div'); extraThumbs.className = 'gallery-pilot-thumbs';
    more.append(summary, extraThumbs);
    root.append(main, controls, thumbs, more, dialog);
    more.hidden = verified || allImages.length < 2;
    let extrasBuilt = false;
    more.addEventListener('toggle', () => {
      if (!more.open || extrasBuilt) return;
      extrasBuilt = true;
      allImages.forEach((entry, n) => {
        const button = document.createElement('button'); button.type = 'button'; button.setAttribute('aria-label', `${config.labels.view} ${n + 1}`);
        const thumb = document.createElement('img'); const url = new URL(entry.src); url.searchParams.set('width', '150');
        thumb.src = url.href; thumb.alt = entry.alt; thumb.width = 90; thumb.height = 90; thumb.loading = 'lazy';
        button.append(thumb); button.addEventListener('click', () => {
          entries = allImages; show(n);
          requestAnimationFrame(revealSelectedImage);
          controls.hidden = false; thumbs.hidden = true;
        }); extraThumbs.append(button);
      });
    });
    let entries = [], active = 0, key;
    function show(index) {
      active = (index + entries.length) % entries.length;
      const entry = entries[active];
      const url = new URL(entry.src); url.searchParams.set('width', '1000');
      image.src = url.href; image.alt = entry.alt;
      zoom.src = entry.src; zoom.alt = entry.alt;
      counter.textContent = `${active + 1} / ${entries.length}`;
      [...thumbs.children].forEach((b, n) => b.setAttribute('aria-pressed', String(n === active)));
    }
    function select(id, variant) {
      if (!mapping.variants[String(id)] && !verified && variant?.featured_media?.preview_image?.src) {
        const k = String(id); mapping.variants[k] = k;
        mapping.groups[k] = [{src:new URL(variant.featured_media.preview_image.src, location.origin).href, alt:product.title + ', ' + variant.title}];
      }
      const group = mapping.variants[String(id)];
      if (!group || group === key) return;
      key = group; entries = mapping.groups[group]; thumbs.replaceChildren();
      more.open = false; thumbs.hidden = entries.length < 2; controls.hidden = entries.length < 2;
      entries.forEach((entry, n) => {
        const button = document.createElement('button'); button.type = 'button';
        button.setAttribute('aria-label', `${config.labels.view} ${n + 1}`);
        const thumb = document.createElement('img'); const url = new URL(entry.src); url.searchParams.set('width', '150');
        thumb.src = url.href; thumb.alt = entry.alt; thumb.width = 90; thumb.height = 90; thumb.loading = 'lazy';
        button.append(thumb); button.addEventListener('click', () => show(n)); thumbs.append(button);
      });
      show(0);
    }
    select(config.variant);
    if (!entries.length) return;
    previous.addEventListener('click', () => show(active - 1)); next.addEventListener('click', () => show(active + 1));
    main.addEventListener('click', () => dialog.showModal()); close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    root.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); show(active + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); show(active - 1); } });
    let start;
    main.addEventListener('touchstart', e => { start = e.changedTouches[0].clientX; }, {passive:true});
    main.addEventListener('touchend', e => { const diff = e.changedTouches[0].clientX - start; if (Math.abs(diff) > 45) show(active + (diff < 0 ? 1 : -1)); }, {passive:true});
    wrapper.prepend(root); wrapper.classList.add('gallery-pilot-ready');
    let lastVariant = String(config.variant);
    function revealSelectedImage() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      const rect = main.getBoundingClientRect();
      const header = document.querySelector('.shopify-section-header-sticky');
      const offset = Math.min(header?.getBoundingClientRect().height || 0, window.innerHeight / 3) + 16;
      if (rect.top >= offset && rect.top < window.innerHeight / 2) return;
      window.scrollTo({
        top: Math.max(0, window.scrollY + rect.top - offset),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.variantChange, event => {
      if (String(event.data.sectionId) !== wrapper.closest('product-info').dataset.section) return;
      const id = String(event.data.variant.id);
      select(id, event.data.variant);
      if (id !== lastVariant) {
        lastVariant = id;
        requestAnimationFrame(revealSelectedImage);
      }
    });
  }).catch(error => console.warn('Gallery pilot retained original gallery:', error));
})();
